var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "w-full h-full mt-1 dot-wrapper",
      class: _vm.index === _vm.last - 1 && "mr-0",
      style:
        _vm.active === _vm.index
          ? "border-color:#0384FB"
          : "border-color:#979797;",
    },
    [
      _c(
        "div",
        {
          staticClass: "w-full h-full flex justify-center align-middle",
          on: {
            click: function ($event) {
              return _vm.$emit("clicked")
            },
          },
        },
        [
          _vm.slide?.sys?.contentType?.sys?.id === "image"
            ? _c("PictureWrapper", {
                staticClass:
                  "w-full h-full object-cover flex justify-center align-middle",
                attrs: {
                  image: _vm.slide?.fields,
                  "custom-scale": "?fit=fill&w=80&h=80&fm=jpg",
                },
              })
            : _vm.slide?.sys?.contentType?.sys?.id === "video"
            ? _c(
                "div",
                {
                  staticClass: "tile--video h-full w-full relative",
                  on: { click: _vm.toggleModal },
                },
                [
                  _vm.slide?.fields?.coverImage
                    ? _c("img", {
                        staticClass: "w-full h-full object-cover",
                        attrs: {
                          src: _vm.slide?.fields?.coverImage?.fields?.file?.url,
                          alt: "yt thumbnail",
                        },
                      })
                    : _c("img", {
                        staticClass: "w-full h-full object-cover",
                        attrs: {
                          src: `https://img.youtube.com/vi/${_vm.slide.fields.id}/hqdefault.jpg`,
                          alt: "yt thumbnail",
                        },
                      }),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass: "absolute",
                      attrs: {
                        width: "37",
                        height: "37",
                        viewBox: "0 0 37 37",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "18.5",
                          cy: "18.5",
                          r: "18.5",
                          fill: "#0384FB",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M23.1868 18.2532L15.7868 22.5255L15.7868 13.9808L23.1868 18.2532Z",
                          fill: "white",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.slide?.sys?.contentType?.sys?.id === "video"
        ? _c(
            "Modal",
            {
              attrs: {
                "is-open": _vm.openModal,
                "close-location": "outer",
                bg: "bg-transparent",
              },
              on: { close: _vm.toggleModal },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "w-full m-auto position-fixed z-50 modal__content",
                },
                [
                  _vm.openModal
                    ? _c("Video", { attrs: { video: _vm.slide?.fields } })
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }